var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "550px",
      "overflow-y": "scroll",
      "width": "100%"
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      "props": _vm.defaultProps,
      "lazy": "",
      "load": _vm.loadNode,
      "filter-node-method": _vm.filterNode,
      "highlight-current": true,
      "accordion": _vm.accordion
    },
    on: {
      "node-click": _vm.nodeSelection
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('div', {}, [_c('div', {
          staticStyle: {
            "display": "inline-block",
            "width": "100%"
          }
        }, [_c('el-divider', {
          attrs: {
            "content-position": "left"
          }
        }, [_vm._v(_vm._s(data.organize_name))]), _vm._v(" "), _c('el-checkbox-group', {
          on: {
            "change": function($event) {
              return _vm.handleCheckboxChangeGroup(data.projectPostList)
            }
          },
          model: {
            value: (_vm.post_ids),
            callback: function($$v) {
              _vm.post_ids = $$v
            },
            expression: "post_ids"
          }
        }, [_c('el-row', {
          staticStyle: {
            "width": "100%",
            "margin-top": "10px"
          }
        }, _vm._l((data.projectPostList), function(post) {
          return _c('el-col', {
            key: post.id,
            staticStyle: {
              "margin-bottom": "5px"
            },
            attrs: {
              "span": 6
            }
          }, [_c('el-checkbox', {
            attrs: {
              "label": post.post_id
            }
          }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(post.post_name) + "\n\t\t\t\t\t\t\t")])], 1)
        }), 1)], 1), _vm._v(" "), _c('hr')], 1)])
      }
    }])
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca4e67f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtqdFQ/SetPost.vue
// module id = null
// module chunks = 